import React from 'react';
import {Text} from '@priority-software/priority-style-react';
import {ReactComponent as EmptySearchIcon} from './ai_search_empty.svg';
import texts from '../../../../../../Localization/AISearch/texts';
import styles from './styles.module.scss';

type Props = {
    showError?: boolean;
};

export const EmptyResponseMsg = (props: Props) => {
    const {showError} = props;
    return (
        <div className={styles.component}>
            <EmptySearchIcon width={60} height={60} />
            {showError ? (
                <Text skin="paragraph-1">{texts.ai_search_error}</Text>
            ) : (
                <Text skin="paragraph-1" textColor="primary-700">
                    {texts.no_relevant_results}
                </Text>
            )}
        </div>
    );
};
